import { render, staticRenderFns } from "./Cbtnsave.vue?vue&type=template&id=52133d9a&"
import script from "./Cbtnsave.vue?vue&type=script&lang=js&"
export * from "./Cbtnsave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports